import React, { useEffect, useState } from 'react'
import SideNav from '../../common/SideNav'
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux';
import { hasSideBar, toggleSideBar, updateCurrentComponent } from '../../../store/actions/navActions';
import { nonEmptyString } from '../../../services/typeUtils';
import { getRuleRunHistory } from '../../../services/api/nbaApi';
import { hideLoading, showLoading } from '../../../store/actions/loadingActions';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import CustomMuiTable from './CustomMuiTable';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const tableHeader = {
    RuleId: 'Rule Id',
    RuleName: 'Rule Name',
    S3FilePath: 'S3 File Path',
    RunTime: 'Run Time(UTC Time)',
    noOfRecord: 'No. Of Records',
    Status: 'Status',
};
const filterColumns = ["RuleId", "RuleName", "S3FilePath", "RunTime", "Status", "noOfRecord"]; 

const RuleRunHistory = () => {
    const { auth, navigation } = useSelector((state) => state);
    const { market, category, brand } = useSelector((state) => state.auth.user);
    const fields = Object.keys(tableHeader);
    const { currentRuleId, currentRuleName } = navigation;
    const [ruleHistory, setRuleHistory] = useState([]);
    const dispatch = useDispatch();
    
    const [page, setPage] = useState(0);
    const navigate = useNavigate();


    const handlePageChange = (event, page) => {
        setPage(page);
    };
    useEffect(()=>{
        dispatch(updateCurrentComponent("Rule Run History"));
        dispatch(hasSideBar(true));
        dispatch(toggleSideBar(false));

        dispatch(showLoading());
        getRuleRunHistory(market, brand, currentRuleId)
        .then((response) => {
            const historyRes = response?.data;
            let historyList = [];
            historyRes?.map((history)=>{
                const ruleHistoryObj = {
                    RuleId: String(currentRuleId),
                    RuleName: currentRuleName?.toUpperCase(),
                    S3FilePath: history?.resultS3Path,
                    RunTime: history?.invokeAtTime,
                    Status: history?.status,
                    noOfRecord: (history?.noOfRecord),

                }
                historyList.push(ruleHistoryObj);
            });
            setRuleHistory(historyList);
        })
        .catch((err) => console.log(err))
        .finally(() => dispatch(hideLoading()));
    },[]);
    const renderFieldContent = (field, rowData)=>{
        if (nonEmptyString(rowData[field]) || typeof rowData[field] === "number") {
            if(field === 'RunTime'){
                return formatInTimeZone(new Date(rowData[field]), 'UTC', 'dd-MM-yyyy HH:mm:ss');
            }
            else {
                return rowData[field];
            }
        }
    }
    const dataFormatter = (rowData, fields) =>{
        const colVal = fields.map((field, idx) =>
             field === 'RuleName' ? (
            <TableCell
                key={idx}
                className="table-cell"
                style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    maxWidth: 250,
                    // textTransform: 'uppercase',
                }}
            >
                {renderFieldContent(field, rowData)}
            </TableCell>
        ) : 
            (
                <TableCell
                    key={idx}
                    className="table-cell"
                    style={{
                        whiteSpace:
                            'normal',
                        wordBreak:
                            'break-word',
                        maxWidth: 250,
                    }}
                >
                    {renderFieldContent(
                        field,
                        rowData
                    )}
                </TableCell>
            ))
        return colVal;
    }
    //console.log("ruleHistory", ruleHistory);
    return (
        <div className="component-container-root">
        <SideNav />
        <div className="create-rule-container"  style={{ paddingTop: '20px' }}>
            <div className="create-rule">
                <div className="create-rule-header">
                    <div className="create-rule-close">
                        <button
                            className="create-rule-close-btn"
                            onClick={() => navigate('/manage-rules')}
                        >
                            <ArrowBackIcon />
                            Back to Manage Rules
                        </button>
                    </div>
                    <div className="create-rule-title">
                        <h3>Rule Run History</h3>
                    </div>
                </div>
            </div>
        </div>
            <Box className="manage-rules-container component-container">
                {/* <h1>Rule Run History</h1> */}
                <div className="manage-rules" style={{ textWrap: 'nowrap' }} >
                    <CustomMuiTable headerColumns={tableHeader} rows={ruleHistory} dataFormatter={dataFormatter} filterColumns={filterColumns} sortingColumns={filterColumns} defaultSortField={"RunTime"} defaultSortOrder={"desc"}/>
                </div>
            </Box>
        </div>
    )
}

export default RuleRunHistory